<template>
  <div width="50%" style="margin-left: 20%;margin-right: 20%;margin-top: 10%;">

    <!-- 编辑界面 -->
    <el-form label-width="200px" :model="editForm.password" :rules="rules" ref="editForm">
      <el-form-item label="修改密码" prop="rightTotal">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.password"></el-input>
        </el-col>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">提交修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapsList, mapsSave } from '../../api/mapsMG2'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      editForm: {
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      mapsList()
        .then(res => {
          console.log(res);
          this.loading = false
          if (res.data.code != 0) {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          } else {
            this.editForm = res.data.data
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          console.log(JSON.stringify(this.editForm));
          mapsSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              console.log(res);
              if (res.data.code == 0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/maps/maps2.vue